/**
 * A/B variant assignment for landing page.
 *
 * Sticky: first visit picks a variant, localStorage persists it forever.
 * GA4 tracks impressions (views), job.job_metadata tracks conversions.
 */

const STORAGE_KEY = 'fth_landing_variant'
const VARIANTS = ['reveal', 'contrast', 'editorial'] as const

export type LandingVariant = (typeof VARIANTS)[number]

/** Get or assign a sticky variant. */
export function getLandingVariant(): LandingVariant {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && VARIANTS.includes(stored as LandingVariant)) {
      return stored as LandingVariant
    }
  } catch {
    // localStorage unavailable (incognito, etc.)
  }

  const variant = VARIANTS[Math.floor(Math.random() * VARIANTS.length)]

  try {
    localStorage.setItem(STORAGE_KEY, variant)
  } catch {
    // best effort
  }

  return variant
}

/** Log a landing page view to GA4 (if loaded). */
export function trackLandingView(variant: LandingVariant) {
  try {
    const gtag = (window as any).gtag
    if (typeof gtag === 'function') {
      gtag('event', 'landing_view', {
        landing_variant: variant,
      })
    }
  } catch {
    // GA4 not loaded yet — that's fine
  }
}

/** Log a CTA click to GA4. */
export function trackLandingCTA(variant: LandingVariant) {
  try {
    const gtag = (window as any).gtag
    if (typeof gtag === 'function') {
      gtag('event', 'landing_cta_click', {
        landing_variant: variant,
      })
    }
  } catch {
    // best effort
  }
}
